import { get } from 'api/helpers';
import env from 'utilities/env';

export const fetchFillAdvisorData = () => get(env('FILL_ADVISOR_AWS_BUCKET'));
export default fetchFillAdvisorData;
